// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"347211e7","415":"b8cf1b26","453":"93e49187","696":"e7831284","723":"750f0a7a","727":"be705bf5","739":"3a2f221c"}[chunkId] + ".chunk.js";
};